import React, { Component } from 'react';
import { Load, LabelWithArrow } from '../common/basic';
import DatePicker from '../common/datepicker';
import { TableHeaderColumn } from 'react-bootstrap-table';
import DataGrid from '../common/dataGrid';
import DropDown from '../common/dropDown';
import { CheckBox, ApplyAndReset } from '../common/forms';
import moment from 'moment';
import enums from '../../config/enums';
import '../../public/less/forms.less';
import dateHelper from '../../helpers/date.js';
import CSVExport from '../common/CSVExport';

var MoreDetailsContainer = React.createClass({
    MoreDetailsRow: function (key, data) {
        return <div key={key}>{data}</div>;
    },
    createContainer: function (data) {
        var columnData = [];
        for (var prop in data) {
            var rowData = prop + " = " + data[prop];
            columnData.push(this.MoreDetailsRow(prop, rowData));
        }
        return columnData;
    },
    render: function () {
        return (
            <div>{this.createContainer(this.props.data)}</div>
        )
    }
});

// Search Panel
class LogSearch extends Component {

    constructor(props) {
        super(props);

        this.state = this.props.getDefaultParams();

        this.operationChanged = this
            .operationChanged
            .bind(this);
    };

    getSearchParams() {
        var params = this.state;

        return params;
    }


    setDefault(params) {
        this.setState(params);

        this._deviceActivites.resetSelected();
        this._patientActivites.resetSelected();

        this._LLLT.unCheck();
        this._RF.unCheck();
        this._ELP.unCheck();
        this._Sebum.unCheck();
        this._Elasticity.unCheck();
        this._Humidity.unCheck();
    }

    setSearchParams(params) {
        this.setState(params);
    }

    operationChanged(id, isChecked) {
        var operations = this.state.operationIDs;
        if (!isChecked) {
            var index = operations.indexOf(id);
            if (index > -1) {
                operations.splice(index, 1);
            }
        } else {
            operations.push(id);
        }

        this.setState({ operationIDs: operations });
    }

    changeFrom(date) {
        this.setState({ fromDate: date });
    }

    changeTo(date) {
        this.setState({ toDate: date });
    }

    render() {
        var style = {
            width: '950px',
            height: '135px'
        }
        return (
            <div className="SearchContainer float-left" style={style}>
                <div className='float-left right-border' >
                    <DatePicker
                        className='display-table'
                        Label='From date'
                        type="start"
                        startDate={this.state.fromDate}
                        endDate={this.state.toDate}
                        onChange={this
                            .changeFrom
                            .bind(this)} />
                    <DatePicker
                        className='display-table'
                        Label='To date'
                        type="end"
                        startDate={this.state.fromDate}
                        endDate={this.state.toDate}
                        ContainerType='input'
                        onChange={this
                            .changeTo
                            .bind(this)} />
                </div>
                <div className='float-left'>
                    <h5>Treatment</h5>
                    <CheckBox
                        id={enums.LOG_OPERATIONS.LLLT}
                        onChange={this.operationChanged}
                        ref={(LLLT) => { this._LLLT = LLLT; }} >LLLT</CheckBox>
                    <CheckBox
                        id={enums.LOG_OPERATIONS.RF}
                        onChange={this.operationChanged}
                        ref={(RF) => { this._RF = RF; }}>RF</CheckBox>
                    <CheckBox
                        id={enums.LOG_OPERATIONS.EMT}
                        onChange={this.operationChanged}
                        ref={(ELP) => { this._ELP = ELP; }}>ELP</CheckBox>
                </div>
                <div className='float-left right-border'>
                    <h5>Measurment</h5>
                    <CheckBox
                        id={enums.LOG_OPERATIONS.HUMIDITY}
                        onChange={this.operationChanged}
                        ref={(Humidity) => { this._Humidity = Humidity; }}>Humidity</CheckBox>
                    <CheckBox
                        id={enums.LOG_OPERATIONS.SEBUM}
                        onChange={this.operationChanged}
                        ref={(Sebum) => { this._Sebum = Sebum; }}>Sebum</CheckBox>
                    <CheckBox
                        id={enums.LOG_OPERATIONS.ELASTICITY}
                        onChange={this.operationChanged}
                        ref={(Elasticity) => { this._Elasticity = Elasticity; }}>Elasticity</CheckBox>
                </div>
                <div className='float-left'>
                    <DropDown
                        id="Device"
                        Label="Device activities"
                        checkedArray={this.state.operationIDs}
                        isChecked={this.isChecked}
                        Data={DeviceOptions}
                        onChange={this.operationChanged}
                        ref={(deviceActivites) => { this._deviceActivites = deviceActivites; }} />
                </div>
                <div className='float-left'>
                    <ApplyAndReset
                        Search={this
                            .props
                            .Search
                            .bind(this)}
                        ApplyReset={this
                            .props
                            .ApplyReset
                            .bind(this)} />
                </div>
                <div className='float-left'>
                                <CSVExport 
                                ajaxUrl='/data/getLogs' 
                                parameters={this.state} 
                                dbKeys={['ID', 'TimeStamp', 'User', 'SerialNumber', 'Operation', 'Status', 'FirstDetail', 'Details']} 
                                csvKeys={['ID', 'Date', 'Patient name', 'Device info', 'Operation', 'Status', 'Info', 'More Info']}
                                fileName={'Logs_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>
                </div>
            </div>
        )
    }
}

module.exports = class PatientActions extends Component {
    constructor(props) {
        super(props);

        this.state = this.getDefaultParams();
        this.getDefaultParams = this.getDefaultParams.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSizePerPageList = this.onSizePerPageList.bind(this);
    }

    isExpandable(row) {
        if (row.Details == null)
            return false;
        return true;
    }

    trClassFormat(row, rowIndex) {
        if (row.isExpanded)
            return 'tr-expanded';

        // row is the current row data
        return rowIndex % 2 === 0
            ? "tr-odd"
            : "tr-even"; // return class name.
    }

    expandComponent(row) {
        var allDetails = JSON.parse(row.Details);

        return (
            <table className='exapandbleRowTable'>
                <tbody>
                    <tr>
                        <td></td>
                        <td>More details</td>
                        <td></td>
                        <td></td>
                        <td><MoreDetailsContainer data={allDetails} /></td>
                        <td width='19'></td>
                    </tr>
                </tbody>
            </table>
        );
    }

    rowClick(row) {
        if (row.isExpanded == undefined || row.isExpanded == false)
            row.isExpanded = true;
        else
            row.isExpanded = false;
    }

    Search() {
        var params = this
            ._logSearch
            .getSearchParams();

        this.setState(params);
        this
            ._dataGrid
            .setNewParameters(this.GetParams(params));
    }

    ApplyReset() {
        this.setState(this.getDefaultParams());

        this
            ._dataGrid
            .setNewParameters(this.getDefaultParams());

        this
            ._logSearch
            .setDefault(getDefaultParams());
    }

    onSortChange(sortName, sortOrder) {
        var params = this.state;

        params.sortOrder = sortOrder;
        params.sortName = sortName;

        this.setState({
            sortOrder: sortOrder,
            sortName: sortName,
        });

        this._logSearch.setSearchParams(params);
        this._dataGrid.setNewParameters(this.GetParams(params));
    }

    onPageChange(page, sizePerPage) {
        var params = this.state;

        params.pageNumber = page;
        params.itemsPerPage = sizePerPage;

        this.setState({
            pageNumber: page,
            itemsPerPage: sizePerPage
        });

        this._logSearch.setSearchParams(params);
        this._dataGrid.setNewParameters(this.GetParams(params));
    }

    onSizePerPageList(sizePerPage) {
        var params = this.state;

        params.itemsPerPage = sizePerPage;

        this.setState({
            itemsPerPage: sizePerPage
        });

        this._logSearch.setSearchParams(params);
        this._dataGrid.setNewParameters(this.GetParams(params));
    }

    GetParams(params) {
        var newParams = {
            fromDate: params.fromDate.toLocaleDateString(),
            toDate: params.toDate.toLocaleDateString(),
            userText: '',
            userID: this.props.patientID,
            operationIDs: params.operationIDs,
            sortOrder: params.sortOrder,
            sortName: params.sortName,
            pageNumber: params.pageNumber,
            itemsPerPage: params.itemsPerPage
        }
        return newParams;
    }

    getDefaultParams() {
        const DefaultParams = {
            fromDate: new Date(y, m, 1),
            toDate: new Date(y, m + 1, 0),
            userText: '',
            userID: 0,
            user: {
                ID: 0,
                text: ''
            },
            operationIDs: [],
            sortOrder: 'Desc',
            sortName: 'TimeStamp',
            pageNumber: 0,
            itemsPerPage: 10
        } // create a copy of the array
        DefaultParams.operationIDs = defaultOperations.concat();

        return DefaultParams;
    }

    render() {
        var params = this.GetParams(this.state);
        return (
            <div>
                <h3>Logs</h3>
                <LogSearch getDefaultParams={this.getDefaultParams}
                    ref={(logSearch) => {
                        this._logSearch = logSearch;
                    }}
                    ApplyReset={this
                        .ApplyReset
                        .bind(this)}
                    Search={this
                        .Search
                        .bind(this)} />
                <div>
                    <DataGrid
                        ref={(dataGrid) => {
                            this._dataGrid = dataGrid;
                        }}
                        ajaxUrl='/data/getLogsPaging'
                        ID='grid1'
                        parameters={params}
                        OnClick={this.rowClick}
                        ExpandableRow={this.isExpandable}
                        trClassFormat={this.trClassFormat}
                        ExpandComponent={this.expandComponent}
                        pagination={true}
                        remote={true}onSortChange={this.onSortChange}
                        onPageChange={this.onPageChange}
                        onSizePerPageList={this.onSizePerPageList}
                        totelDataUrl="/data/GetLogCount"
                        page={this.state.pageNumber}
                        sizePerPage={this.state.itemsPerPage}>
                        <TableHeaderColumn isKey hidden dataField='ID' />
                        <TableHeaderColumn dataField='TimeStamp' dataFormat={dateFormatter} dataSort>Date</TableHeaderColumn>
                        <TableHeaderColumn dataField='SerialNumber' dataSort>Device info</TableHeaderColumn>
                        <TableHeaderColumn dataField='Operation' dataSort>Operation</TableHeaderColumn>
                        <TableHeaderColumn dataField='Status' dataSort>Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='FirstDetail'>More Info</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataFormat={moreDetailsFormatter} width='35'></TableHeaderColumn>
                    </DataGrid>
                </div>

            </div>
        )
    }
};

var DeviceOptions = [
    {
        id: enums.LOG_OPERATIONS.DEVICE_CONNECTED,
        name: 'Device connected'
    }, {
        id: enums.LOG_OPERATIONS.DEVICE_DISCONNECTED,
        name: 'Device disconnected'
    }, {
        id: enums.LOG_OPERATIONS.DEVICE_ERROR,
        name: 'Device error'
    }, {
        id: enums.LOG_OPERATIONS.CHANGE_UNIT,
        name: 'Device replacement'
    }
];


var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();

// don't forget to change the objects (DeviceOptions, PatientOptions etc.) too.
var defaultOperations = [];



function dateFormatter(cell, row) {
    return `${dateHelper.fromDBStrToStrWithTime(cell)}`;
}

/* More Details */
function moreDetailsFormatter(cell, row, enumObject, index) {
    if (row.Details == null)
        return (
            <div></div>
        );
    if (row.isExpanded != undefined && row.isExpanded == true)
        return (
            <div className='MoreInfo'>-</div>
        );
    else
        return (
            <div className='MoreInfo'>+</div>
        );
}


// WEBPACK FOOTER //
// ./modules/patientSummary/PatientActions.jsx